/* src/app/app.component.scss */
ion-menu {
  --max-width: 350px;
  --width: 100%;
}
ion-menu ion-header,
ion-menu ion-content {
  --background: black;
}
ion-menu ion-header ion-item,
ion-menu ion-header ion-toolbar,
ion-menu ion-header ion-list,
ion-menu ion-content ion-item,
ion-menu ion-content ion-toolbar,
ion-menu ion-content ion-list {
  --background: black;
}
ion-menu ion-header .list-ios,
ion-menu ion-content .list-ios {
  background: black !important;
}
ion-menu ion-header a,
ion-menu ion-content a {
  text-decoration: none;
}
ion-menu ion-header ion-item::part(native),
ion-menu ion-content ion-item::part(native) {
  padding-inline: 5px;
}
ion-menu .user-name {
  color: white !important;
  font-family: "League Spartan", sans-serif;
  font-size: 22px;
  font-weight: 600;
}
ion-menu ion-list {
  padding: 5px 30px !important;
}
@media screen and (max-width: 800px) {
  ion-menu ion-list {
    padding: 20px 10px !important;
  }
}
ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}
ion-menu.md ion-list {
  padding: 20px 0;
}
ion-menu.md ion-note {
  margin-bottom: 30px;
}
ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}
ion-menu.md ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}
ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 600;
  min-height: 20px;
}
ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}
ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}
ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}
ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}
ion-menu.md ion-item ion-icon {
  color: #616e7e;
}
ion-menu.ios ion-content {
  --padding-bottom: 20px;
}
ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}
ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}
ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}
ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}
ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}
ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}
ion-menu.ios ion-note {
  margin-bottom: 8px;
}
ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--ion-color-medium-shade);
}
ion-item.selected {
  --color: var(--ion-color-primary);
}
.user-details-wrapper {
  --ion-grid-column-padding: 0px;
  color: var(--ion-color-lightest);
  padding: var(--page-margin);
  padding-top: 20px;
  align-items: center;
  margin: auto;
}
.user-details-wrapper + .user-details-wrapper {
  padding-top: 0px;
}
.no-break {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info {
  padding: 0 10px;
  color: gray;
  font-size: 12px;
}
.paperplane {
  position: relative;
  overflow: hidden;
  width: 400px;
  height: 400px;
  background-color: #50befa;
  border-radius: 50%;
}
.plane {
  position: absolute;
  left: 200px;
  top: 150px;
  animation: move 3s linear infinite;
}
@keyframes move {
  0% {
    transform: translateY(0) rotateX(0);
  }
  25% {
    transform: translateY(-30px) rotateX(40deg);
  }
  50% {
    transform: rotateX(0) translateY(0);
  }
  75% {
    transform: rotateX(-40deg) translateY(30px);
  }
  100% {
    transform: rotateX(0) translateY(0);
  }
}
.wingRight {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 22.5px solid transparent;
  border-right: 12.5px solid transparent;
  border-bottom: 115px solid white;
  transform: rotate(61deg);
  z-index: 4;
}
.bottom {
  position: relative;
  width: 0;
  height: 0;
  border-left: 12.5px solid transparent;
  border-right: 12.5px solid transparent;
  border-bottom: 25.5px solid #676d70;
  top: 71px;
  transform: rotate(-5deg);
  left: -52.5px;
  z-index: 3;
}
.top {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 30px solid #c1c7c9;
  top: 65px;
  transform: rotate(5deg);
  left: -60px;
  z-index: 1;
}
.middle {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 135px solid #c1c7c9;
  top: -13.5px;
  transform: rotate(72deg);
  left: -7.5px;
  z-index: 2;
}
.wingLeft {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 25px solid transparent;
  border-bottom: 135px solid white;
  transform: rotate(78deg) skewY(-35deg);
  left: -18.5px;
  z-index: 3;
  top: -30px;
}
.clouds {
  position: absolute;
  top: 50px;
  left: 100px;
}
@keyframes cloud {
  from {
    left: -150px;
  }
  to {
    left: 400px;
  }
}
.cloudOne,
.cloudTwo,
.cloudThree {
  position: absolute;
  width: 50px;
  height: 25px;
  background-color: #fff;
  border-radius: 100px 100px 0 0;
}
.cloudOne {
  top: 0;
  left: 0;
  animation: cloud 3s linear infinite reverse;
}
.cloudTwo {
  top: 50px;
  left: 100px;
  animation: cloud 2.5s linear infinite reverse;
}
.cloudThree {
  top: 250px;
  left: 50px;
  animation: cloud 2.8s linear infinite reverse;
}
.cloudOne:before,
.cloudTwo:before,
.cloudThree:before {
  content: "";
  position: absolute;
  width: 25px;
  height: 12.5px;
  background-color: #fff;
  border-radius: 100px 100px 0 0;
  left: -20px;
  top: 12.5px;
  box-shadow: 65px 0 #fff;
}
ion-menu-toggle svg,
ion-menu-toggle ion-icon {
  width: 24px;
  height: 24px;
  fill: white;
  color: white;
}
ion-menu-toggle ion-label,
ion-menu-toggle h3,
ion-menu-toggle a {
  color: white !important;
  font-family: "League Spartan", sans-serif !important;
  font-weight: 400 !important;
  font-size: 22px !important;
  cursor: pointer;
}
.separator {
  height: 40px;
}
.loginSection {
  margin-top: 20px;
}
.loginSection ion-menu-toggle ion-button {
  --color: white !important;
  transition: all 0.2s ease-in-out;
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  --border-radius: 10px;
  height: auto !important;
}
.loginSection ion-menu-toggle ion-button::part(native) {
  background: black;
  transition: all 0.2s ease-in-out;
  padding: 7px 10px 5px 10px;
}
.loginSection ion-menu-toggle:first-of-type ion-button::part(native) {
  border: 1px solid white;
}
.loginSection ion-menu-toggle:hover ion-button {
  opacity: 1 !important;
  transition: all 0.2s ease-in-out;
}
.loginSection ion-menu-toggle:hover:nth-of-type(1) ion-button::part(native) {
  background: var(--ion-color-secondary) !important;
  border: 1px solid var(--ion-color-secondary) !important;
}
.loginSection ion-menu-toggle:hover:nth-of-type(2) ion-button {
  --color: var(--ion-color-secondary) !important;
}
.loaderApp {
  width: 100%;
  margin: auto;
  max-width: 700px;
  background: white;
}
.menu-content {
  background-color: black;
}
.closeMenuBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  height: auto;
  z-index: 99;
}
.closeMenuBtn::part(native) {
  padding: 0;
}
.closeMenuBtn ion-icon {
  color: white;
  font-size: 40px;
}
ion-menu.cart-preview {
  top: 90px;
  --max-width: 770px;
  --width: 770px;
}
ion-menu.cart-preview ion-content {
  --background: #f6f6f6 !important;
}
ion-menu.account-menu {
  top: 85px;
  --width: 100%;
}
ion-menu.faqs-menu {
  top: 90px;
  --max-width: 420px;
  --width: 100%;
  --background: #f6f6f6 !important;
}
@media (min-width: 470px) and (max-width: 850px) {
  ion-menu {
    --max-width: 450px;
  }
}
@media (min-width: 431px) and (max-width: 1024px) {
  ion-menu.cart-preview {
    --width: 443px !important;
  }
}
@media (max-width: 430px) {
  ion-menu.cart-preview {
    --width: 100%;
  }
}
#cart-preview-content {
  position: relative;
}
.close-button {
  color: white;
}
.close-button > ion-icon {
  width: 24px;
  height: 24px;
}
.close-button:hover {
  opacity: 0.85;
}
.close-button:active {
  opacity: 0.7;
}
.avatar {
  height: 24px;
  width: 24px;
}
.list {
  gap: 30px;
}
.list-options {
  gap: 15px;
}
.menu-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px 30px;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  color: white;
  cursor: pointer;
}
/*# sourceMappingURL=app.component-TALWY4IH.css.map */
